<template>
	<layout-page title="Dashboard">
		<!-- control/filter bar  -->
		<my-contracts-filter
			v-model="filter"
			v-if="showFilter"
			v-on:close="closeFilter()"
			:filter-options="filterOptions"
		/>
		<!-- filter bar -->

		<div class="flex-grow flex flex-col bg-gray-100">
			<!-- header -->
			<div
				class="bg-green px-4 sm:px-6 py-4 md:rounded-tl-2xl xl:rounded-t-2xl flex justify-start items-center"
			>
				<h1 class="text-2xl md:text-4xl font-semibold text-white">
					{{ __("My Contracts") }}
				</h1>
			</div>

			<div
				class="px-4 sm:px-6 lg:px-6 py-4 bg-gray-700 flex-wrap flex items-center space-x-4 md:space-x-6"
			>
				<button
					class="relative inline-flex px-2 lg:pr-4 py-1.5 font-medium text-white bg-gray-500 hover:bg-gray-400 rounded-lg flex items-center focus:ring-2 ring-gray-400"
					v-on:click="showFilter = !showFilter"
				>
					<ui-icon
						class="mr-2 flex-shrink-0 h-5 w-5"
						name="filter"
						stroke-width="2"
					/>
					{{ __("Filter") }}
					<span
						class="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-or-50 transform translate-x-1/4 -translate-y-1/2 bg-orange rounded-full"
						v-if="activeFilterCount > 0"
						>{{ activeFilterCount }}</span
					>
				</button>

				<div class="flex items-center space-x-4 text-gray-100">
					<div class="flex items-center">
						<input
							id="nachfrage"
							name="filtertype"
							type="radio"
							v-model="filter.type"
							value="SELL"
							checked="checked"
							class="h-5 w-5 bg-gray-600 border-gray-300 rounded text-orange focus:ring-orange border-gray-200 rounded hover:ring-4 hover:ring-orange-800 cursor-pointer"
						/>
						<label
							for="nachfrage"
							class="pl-3 block font-medium whitespace-nowrap cursor-pointer"
							>{{ __("Sale") }}</label
						>
					</div>
					<div class="flex items-center cursor-pointer">
						<input
							id="angebote"
							name="filtertype"
							type="radio"
							v-model="filter.type"
							value="BUY"
							class="h-5 w-5 bg-gray-600 border-gray-300 rounded text-orange focus:ring-orange hover:ring-4 hover:ring-orange-800 cursor-pointer"
						/>
						<label
							for="angebote"
							class="pl-3 block font-medium whitespace-nowrap cursor-pointer"
							>{{ __("Purchase") }}</label
						>
					</div>
				</div>
			</div>

			<!--content-my-contracts-no-contracts
				v-if="isDummyData"
			></content-my-contracts-no-contracts>

			<content-my-contracts-no-matches
				v-if="filteredContracts.length == 0"
			></content-my-contracts-no-matches-->

			<div class="px-4 sm:px-6 lg:px-6 pt-6 bg-gray-100">
				<div class="py-6 grid grid-cols-2 gap-x-6 gap-y-6">
					<div class="">
						<span v-if="locale == 'en'">
							<h2 class="text-xl sm:text-2xl text-gray-500 font-semibold mb-2">
								Was zeigt Ihnen diese Übersicht?
							</h2>
							<p>
								Das Dashboard "Meine Kontrakte" bietet Ihnen einen schnellen
								Überblick über ihre Handelsaktivitäten hier auf cropspot.
								Außerdem finden Sie hier alle bisher abgeschlossenen Kontrakte
								bequem zum Download.
							</p>
						</span>
						<span v-else>
							<h2 class="text-xl sm:text-2xl text-gray-500 font-semibold mb-2">
								Was zeigt Ihnen diese Übersicht?
							</h2>
							<p>
								Das Dashboard "Meine Kontrakte" bietet Ihnen einen schnellen
								Überblick über ihre Handelsaktivitäten hier auf cropspot.
								Außerdem finden Sie hier alle bisher abgeschlossenen Kontrakte
								bequem zum Download.
							</p>
						</span>
					</div>
					<div class="">
						<span v-if="locale == 'en'">
							<p>
								Behalten Sie Ihre komplette Vermarktung im Blick und binden Sie
								auch externe Kontrakte ein.
							</p>
						</span>
						<span v-else>
							<p>
								Behalten Sie Ihre komplette Vermarktung im Blick und binden Sie
								auch externe Kontrakte ein.
							</p>
						</span>
						<!--ui-button
							label="Please inform me"
							class="shadow-xl mx-auto"
							v-on:click="confirmButtonAction('accept')"
						/-->
						<div class="mt-2 text-center">
							<ui-button
								class="flex items-center flex-shrink-0 mx-auto"
								v-on:click="
									$bus.$emit(
										'toggle-iframe-modal',
										$route('external_contract.create')
									)
								"
							>
								<ui-icon
									class="mr-2 -ml-1 flex-shrink-0 h-5 w-5 text-white"
									name="plus"
									stroke-width="2"
								/>
								<span class="">{{ __("External Contract") }}</span>
							</ui-button>
						</div>
					</div>
				</div>

				<div class="py-6 grid grid-cols-2 gap-x-6 gap-y-6 relative z-0">
					<div
						v-if="isDummyData"
						class="contracts-overlay bg-gray-100 opacity-75 absolute inset-0 w-full h-full z-10"
					></div>

					<div class="contents">
						<my-contracts-summary-tile
							class=""
							:contracts="filteredContracts"
							:key="'QTY_' + JSON.stringify(filter)"
						/>
						<my-contracts-summary-tile
							class=""
							:contracts="filteredContracts"
							:key="'REVENUE_' + JSON.stringify(filter)"
							field="revenue"
						/>
					</div>

					<my-contracts-product-grade-tile
						:contracts="filteredContracts"
						:filterType="filter.type"
						class="col-span-2"
					/>

					<!--
                    <div>

                    </div>
                    -->

					<my-contracts-list
						:contracts="filteredContracts"
						:isDummyData="isDummyData"
						:filterType="filter.type"
						class="col-span-2"
					/>
				</div>
			</div>

			<ui-modal
				:small="true"
				:title="__('Thank you for your interest!')"
				alert-style="check"
				:confirm-label="__('OK')"
				:hasDismissButton="false"
				v-if="showTestButtonThankYouModal"
				v-on:dismiss="closeThankyouModal()"
				v-on:close="closeThankyouModal()"
			>
				<span v-if="locale == 'en'">
					Thank you for your interest! We inform you as soon as this function is
					available.
				</span>
				<span v-else>
					Gerne informieren wir Sie, sobald auch externe Kontrakte eingebunden
					werden können.
				</span>
			</ui-modal>
		</div>
	</layout-page>
</template>

<script>
export default {
	props: {
		contracts: {
			type: Array,
			required: true,
		},
		isDummyData: {
			type: Boolean,
			default: false,
			required: false,
		},
		user: {
			type: Object,
			required: true,
		},
		testButtonThankYouModal: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		let filterOptions = {},
			years = {};

		this.contracts.forEach((c) => (years[1 * c.product__harvest] = true));
		years = Object.keys(years).sort();

		filterOptions.productYears = years.map(function (y) {
			return {
				label: y,
				value: y,
				checked: false,
			};
		});
		let tradedProductGrades = {};
		this.contracts.forEach(function (c) {
			if (c.product__grade.includes("WHEAT_B")) {
				tradedProductGrades["WHEAT_B"] = true;
			} else {
				tradedProductGrades[c.product__grade] = true;
			}
		});

		filterOptions.productGrades = [];
		Object.values(this.$cropOptions.productGradeOptions)
			.flat()
			.forEach((o) => {
				if (o.group && o.default) {
					filterOptions.productGrades.push({
						label: o.group,
						value: o.default,
					});
				} else if (o.group) {
				} else {
					filterOptions.productGrades.push({ label: o.name, value: o.id });
				}
			});

		filterOptions.productGrades = filterOptions.productGrades.filter(
			(option) => tradedProductGrades[option.value] === true
		);

		filterOptions.contractSources = [];
		filterOptions.contractSources.push({ label: "cropspot", value: 1 });
		filterOptions.contractSources.push({
			label: "External",
			value: 2,
		});

		return {
			filter: {
				productGrades: [],
				productYears: [],
				contractSources: [],
				type: "SELL",
			},
			filterOptions: filterOptions,
			showFilter: false,
			showModal: false,
			showTestButtonThankYouModal: this.testButtonThankYouModal,
		};
	},
	created() {
		//?
		if (window.location.hash != "") {
			this.filter.productGrades = [window.location.hash.substr(1)];
		}
	},
	computed: {
		filteredContracts() {
			let f = this.filter,
				selectedType = this.filter.type,
				selectedGrades = f.productGrades,
				selectedHarvests = f.productYears,
				selectedContractSources = f.contractSources;
			console.log(selectedType);
			return this.contracts
				.filter(
					(contract) =>
						selectedGrades.length == 0 ||
						(!contract.product__grade.includes("WHEAT_B") &&
							selectedGrades.includes(contract.product__grade)) ||
						(contract.product__grade.includes("WHEAT_B") &&
							selectedGrades.includes("WHEAT_B"))
				)
				.filter(
					(contract) =>
						selectedHarvests.length == 0 ||
						selectedHarvests.includes(contract.product__harvest)
				)
				.filter((contract) => selectedType == contract.trade)
				.filter(
					(contract) =>
						selectedContractSources.length == 0 ||
						selectedContractSources.includes(
							contract.is_external_contract ? 2 : 1
						)
				);
		},
		activeFilterCount() {
			return Object.values(this.filter).flat().length - 1; // it's -1 because the type filter is always active
		},
		logoUrl: () => window.baseUrl + "/images/cropspot-logo.svg",
	},
	methods: {
		closeFilter() {
			this.showFilter = false;
		},
		openModal() {
			this.showModal = true;
		},
		confirmButtonAction(actionId) {
			let maintainExternalContacts = null;
			if (actionId == "accept") {
				this.showModal = false;
				maintainExternalContacts = true;
			} else if (actionId == "reject") {
				this.showModal = false;
				maintainExternalContacts = false;
			} else if (actionId == "cancel") {
				this.showModal = false;
				maintainExternalContacts = false;
			}

			this.$inertia.visit(this.$page.url, {
				data: {
					id: this.user.id,
					maintain_external_contacts: maintainExternalContacts,
				},
				method: "post",
				preserveState: false,
				preserveScroll: true,
			});
		},
		closeThankyouModal() {
			this.showTestButtonThankYouModal = false;
		},
	},
};
</script>
